import { render, staticRenderFns } from "./TaxFeesReceiptsPrint.vue?vue&type=template&id=34ef8d5e&scoped=true&"
import script from "./TaxFeesReceiptsPrint.vue?vue&type=script&lang=js&"
export * from "./TaxFeesReceiptsPrint.vue?vue&type=script&lang=js&"
import style0 from "./TaxFeesReceiptsPrint.vue?vue&type=style&index=0&id=34ef8d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef8d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSimpleTable})
